import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import {
  baseCurrencyCode,
  prefixCcySymbol,
  suffixCcySymbol,
  thousandSeparatorByCurrency,
  decimalSeparatorByCurrency,
  decimalScaleByCurrency,
} from "../../utils/Currency";
import { useApp } from "../../contexts";
import { SUBSCRIPTION } from "../../constants";
import { cancelSubscription } from "../../services/app";
import { dateFormatNumber } from "../../utils/helper";
import { ModalConfirm } from "./ModalConfirm";
import * as Notification from "../../Notification"
import { useNavigate } from "react-router-dom";
import environment from "../../environment";

function ItemSubscriptionMarketV2(props) {
  const { T, user, convertToLocalCurrency, formatLocalCurrency, getCurrency } =
    useApp();
  const { itemData, handleReload, subLink } = props;
  const [price, setPrice] = useState(0);
  const [isOpenModalCancel, setIsOpenModalCancel] = useState(false);
  const [isOpenModalCancelSuccess, setIsOpenModalCancelSuccess] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (itemData) {
      setPrice(
        convertToLocalCurrency(itemData.price, itemData.ccy, getCurrency())
      );
    }
  }, [itemData]);

  const openModalCancelSubscription = () => {
    setIsOpenModalCancel(true);
  };

  const handleCancelSubscription = () => {
    if (isLoading) return;
    setIsLoading(true);
    cancelSubscription(itemData.id)
      .then((res) => {
        if (res.data?.data) {
          setIsOpenModalCancel(false);
          handleReload();
          Notification.success(
            T("Success! Your subscription has been canceled!")
          );
        } else {
          Notification.error(T("Failed to cancel subscription"));
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        Notification.error(T("Failed to cancel subscription"));
      });
  };
  const handleChangeCard = () => {
    // setSubOrderData({orderId: itemData?.orderId, subscription_id: itemData?.id});
    // navigate(`/card-information`);
    window.open(
      `${environment.MARKETPLACE_URL}/card-information?subId=${itemData?.id}&senid=${itemData?.orderId}&token=${user?.token}`
    );
  };
  const handleRenew = () => {
    // setSubOrderData({orderId: itemData?.orderId, subscription_id: itemData?.id});
    // navigate(`/card-information`);
    window.open(
      `${environment.MARKETPLACE_URL}/payment-credix?subId=${itemData?.id}&senid=${itemData?.orderId}&token=${user?.token}`
    );
  };
  return (
    <>
      <div className={`w-auto item-boxs suzu-card !border-none cursor-pointer`}>
        <div
          className={`lg:px-[11px] lg:py-[12px] p-[10px] pb-[14px] rounded-t-[13px] rounded-b-[0] flex flex-col items-center justify-center relative
           ${
             [SUBSCRIPTION.PREMIUM, SUBSCRIPTION.ESSENTIAL].includes(
               itemData?.subscriptionId
             )
               ? "bg-[#F3850F1A] "
               : "bg-black"
           }
          `}
        >
          <div
            className={`lg:text-[16px] xs:text-[14px] text-[16px] tracking-[-0.635px] ${
              [SUBSCRIPTION.PREMIUM, SUBSCRIPTION.ESSENTIAL].includes(
                itemData?.subscriptionId
              )
                ? `text-[#000000]`
                : `text-[#ffffff]`
            } font-bold uppercase`}
          >
            <span>
              {itemData?.subscriptionId == SUBSCRIPTION.UNLIMITED
                ? T("UNLIMITED SUBSCRIPTION")
                : itemData?.subscriptionId == SUBSCRIPTION.PREMIUM
                ? T("PREMIUM SUBSCRIPTION")
                : T("ESSENTIAL SUBSCRIPTION")}
            </span>
          </div>
        </div>
        <div
          className={`flex items-center justify-center ${
            itemData?.subscriptionId === SUBSCRIPTION.UNLIMITED
              ? "mt-[16px]"
              : "mt-[23px]"
          }`}
        >
          {itemData?.subscriptionId === SUBSCRIPTION.PREMIUM && (
            <img
              src="assets/images/otc/sub-premium.svg"
              alt=""
              className="w-[122px]"
            />
          )}
          {itemData?.subscriptionId === SUBSCRIPTION.UNLIMITED && (
            <img src="assets/images/otc/sub-unlimited.svg" alt="" />
          )}
          {itemData?.subscriptionId === SUBSCRIPTION.ESSENTIAL && (
            <img src="assets/images/otc/sub-essential.svg" alt="" />
          )}
        </div>
        <div className="mt-[8px] mb-[5px] flex items-center justify-center">
          <span
            className={`text-[16px] ${
              [SUBSCRIPTION.PREMIUM, SUBSCRIPTION.ESSENTIAL].includes(
                itemData?.subscriptionId
              )
                ? `text-[#000000]`
                : `text-aia-red`
            }`}
          >
            &nbsp;
          </span>
          <div>
            <span
              className={`${
                [SUBSCRIPTION.PREMIUM, SUBSCRIPTION.ESSENTIAL].includes(
                  itemData?.subscriptionId
                )
                  ? `text-[#000000]`
                  : `text-aia-red`
              } md:text-[24px] lg:text-[24px] text-[28px] font-bold`}
            >
              <NumberFormat
                className=""
                value={price}
                displayType={"text"}
                thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
                decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
                prefix={prefixCcySymbol(true, getCurrency())}
                suffix={suffixCcySymbol(true, getCurrency())}
                decimalScale={decimalScaleByCurrency(
                  baseCurrencyCode(true, getCurrency())
                )}
              />
              &nbsp;
            </span>
            <span
              className={`${
                [SUBSCRIPTION.PREMIUM, SUBSCRIPTION.ESSENTIAL].includes(
                  itemData?.subscriptionId
                )
                  ? `text-[#000000]`
                  : `text-aia-red`
              }`}
            >
              /{T("month")}
            </span>
            {[SUBSCRIPTION.PREMIUM, SUBSCRIPTION.ESSENTIAL].includes(
              itemData?.subscriptionId
            ) ? (
              <div
                style={{
                  borderBottom: "3px solid #000000",
                  margin: "0 auto",
                }}
                className="w-[90%]"
              ></div>
            ) : (
              <div
                style={{
                  borderBottom: "3px solid #4D67C1",
                  margin: "0 auto",
                }}
                className="w-[90%]"
              ></div>
            )}
          </div>
        </div>
        <div
          className={`flex flex-col items-center lg:px-[20px] lg:pt-[18px] lg:pb-[15px] px-[30px] py-[20px] ${
            [SUBSCRIPTION.ESSENTIAL, SUBSCRIPTION.PREMIUM].includes(
              itemData?.subscriptionId
            )
              ? "h-[114px]"
              : "h-[95px]"
          }`}
        >
          {itemData.inMarket &&
            itemData.status == 1 &&
            itemData.cancelWhenPeriodEnd != 1 && (
              <div
                className="mt-[16px] italic mb-[5px] text-[14px] text-normal text-[#F3850F] text-center hover:underline cursor-pointer"
                onClick={() => {
                  openModalCancelSubscription();
                }}
              >
                {T("Cancel Subscription")}
              </div>
            )}
          {itemData.status == 1 && itemData.user_canceled === 0 && (
            <div
              className="mt-[16px] italic mb-[5px] text-[14px] text-normal text-[#F3850F] text-center hover:underline cursor-pointer"
              onClick={() => {
                openModalCancelSubscription();
              }}
            >
              {T("Cancel Subscription")}
            </div>
          )}
          {["JP", "KR"].includes(user.country_code) &&
            [1].includes(itemData.status) &&
            itemData.inMarket &&
            itemData.cancelWhenPeriodEnd != 1 && (
              <div
                className="mt-[5px] italic mb-[8px] text-[14px] text-normal text-[#F3850F] text-center hover:underline cursor-pointer"
                onClick={() => {
                  handleChangeCard();
                }}
              >
                {T("Update card info")}
              </div>
            )}
          {user.country_code == "JP" &&
            [5].includes(itemData.status) &&
            itemData.inMarket &&
            itemData.cancelWhenPeriodEnd != 1 && (
              <>
                <div
                  className="text-white border-[#000] bg-black px-[25px] py-[6px] rounded-[10px]"
                  onClick={() => {
                    handleRenew();
                  }}
                >
                  {T("Renew now")}
                </div>
                <div className="mt-[24px] italic mb-[5px] text-[14px] text-[#FF5748] text-center cursor-default">
                  {T("Waiting to renew")}
                </div>
              </>
            )}
          {user.country_code == "JP" &&
            [6].includes(itemData.status) &&
            itemData.inMarket &&
            itemData.cancelWhenPeriodEnd != 1 && (
              <>
                <div className="text-white border-[#C3C2C2] bg-[#DEDEDE] px-[25px] py-[6px] rounded-[10px] cursor-default">
                  {T("Renew")}
                </div>
                <div className="mt-[24px] mb-[5px] text-[14px] text-[#000] text-center cursor-default w-full whitespace-normal">
                  {T(
                    "Please wait 1 minute for this subscription payment status update."
                  )}
                </div>
              </>
            )}
          {itemData.inMarket && itemData.cancelWhenPeriodEnd == 1 && (
            <div className="mt-[24px] italic mb-[5px] text-[14px] text-[#FF5748] text-center">
              {T("Cancelled")}
            </div>
          )}
        </div>
        <div
          className={`bg-[#F3850F1A] rounded-b-[13px] rounded-t-[0] 
        flex justify-center items-center text-[12px] text-black ${
          [SUBSCRIPTION.PREMIUM, SUBSCRIPTION.ESSENTIAL].includes(
            itemData?.subscriptionId
          )
            ? "h-[26px]"
            : "h-[27px]"
        }`}
        >
          {T("Next payment: {date}").replace(
            "{date}",
            dateFormatNumber(itemData?.endDate, "YYYY/MM/DD")
          )}
        </div>
      </div>
      {isOpenModalCancel && (
        <ModalConfirm
          title={T("Cancel Subscription")}
          des={T(
            "Are you sure you want to cancel this subscription? After confirm, the subscription charge will be canceled on {date} and you will not be able to resubscribe to that subscription."
          ).replace(
            "{date}",
            dateFormatNumber(itemData?.end_date, "YYYY/MM/DD")
          )}
          onClose={() => setIsOpenModalCancel(false)}
          onSubmit={() => handleCancelSubscription()}
          isLoading={isLoading}
        />
      )}
    </>
  );
}

export default ItemSubscriptionMarketV2;
